export const PREDEFINED_COLORS: Array<[number, number, number]> = [
    [31, 120, 180],
    [178, 223, 138],
    [251, 154, 153],
    [227, 26, 28],
    [166, 206, 227],
    [253, 191, 111],
    [51, 160, 44],
    [255, 127, 0],
    [202, 178, 214],
    [106, 61, 154],
    [255, 255, 153],
    [177, 89, 40],
];

export const CLASSIFICATION_COLORS: Array<[number, number, number]> = [
    [77, 77, 77], // 0: never classified
    [204, 204, 204], // 1: unclassified
    [128, 89, 38], // 2: ground
    [102, 204, 102], // 3: low vegetation
    [0, 255, 0], // 4: medium vegetation
    [0, 153, 0], // 5: high vegetation
    [230, 230, 0], // 6: building
    [255, 77, 179], // 7: noise
    [179, 51, 230], // 8: keypoint
    [77, 77, 230], // 9: water
];

const COLOR_CACHE: Record<string, [number, number, number]> = {};
let _next_color_id = 0;

export function getCachedColor(id: string | null) {
    if (!id) {
        return [0, 0, 0] as [number, number, number];
    }

    if (id in COLOR_CACHE) {
        return COLOR_CACHE[id];
    } else if (_next_color_id < PREDEFINED_COLORS.length) {
        const color = PREDEFINED_COLORS[_next_color_id];
        COLOR_CACHE[id] = color;
        _next_color_id += 1;

        return color;
    } else {
        const random_color = [
            Math.floor(Math.random() * 128) + 64,
            Math.floor(Math.random() * 128) + 64,
            Math.floor(Math.random() * 128) + 64,
        ] satisfies [number, number, number];

        COLOR_CACHE[id] = random_color;

        return random_color;
    }
}

export function getClassificationColor(classification: number) {
    if (classification < CLASSIFICATION_COLORS.length) {
        return CLASSIFICATION_COLORS[classification];
    } else {
        // fallback / default
        const O = 0.25;
        const x = classification / 16.0;
        const r = Math.floor(256 * (0.5 + 0.5 * Math.cos(2.0 * Math.PI * (2.0 * x + 0.0 + O))));
        const g = Math.floor(256 * (0.5 + 0.5 * Math.cos(2.0 * Math.PI * (1.0 * x + 0.66 + O))));
        const b = Math.floor(256 * (0.5 + 0.5 * Math.cos(2.0 * Math.PI * (1.0 * x + 0.33 + O))));
        return [r, g, b];
    }
}
